import { PlusCircleSVG } from "@/components/svg";
import { twMerge } from "tailwind-merge";

export default function AddButton({ className, children, onClick }) {
  return (
    <button
      type="button"
      className={twMerge(
        "pill-button group flex justify-center items-center",
        "bg-bg-purple border-transparent hover:bg-disabled-purple",
        "font-normal text-sm text-dark-purple w-full h-10",
        "focus:outline-light-purple",
        className
      )}
      onClick={onClick}
    >
      <PlusCircleSVG /> {children}
    </button>
  );
}
